import { names } from '@prolaera/library';

export default function() {
  return category => names[category.toLowerCase()] || category;
}



// WEBPACK FOOTER //
// ./src/app/filters/CategoryName.js